import {
  PURCHASE_BUTTON_INFO_START,
  PURCHASE_BUTTON_INFO_SUCCESS,
  PURCHASE_BUTTON_INFO_ERROR,
  PURCHASE_BUTTON_INFO_CLEAR,
} from 'actions/payway';
import {
  purchaseButtonInfoService,
  purchaseButtonInfoServiceV2,
} from 'api/services/payway';
import { getRegion } from 'utils/Region';

export const getPurchaseButtonInfo = params => async (dispatch, getState) => {
  const claroAdEnable =
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.[
      getRegion()
    ]?.enable ||
    JSON.parse(getState().metadata?.cv_advertising_config || '{}')?.default
      ?.enable;
  dispatch({ type: PURCHASE_BUTTON_INFO_START });
  try {
    const response = await purchaseButtonInfoService({
      ...params,
      claroAdEnable: claroAdEnable,
    }).then(({ data }) => data.response);
    dispatch({
      type: PURCHASE_BUTTON_INFO_SUCCESS,
      payload: { ...response, group_id: params.group_id },
    });
  } catch (error) {
    dispatch({
      type: PURCHASE_BUTTON_INFO_ERROR,
      error,
    });
  }
};

export const getPurchaseButtonInfoForEPGTransactions = params => async (
  dispatch,
  getState,
) => {
  dispatch({ type: PURCHASE_BUTTON_INFO_START });
  try {
    const response = await purchaseButtonInfoServiceV2({
      ...params,
    }).then(({ data }) => data.response);
    dispatch({
      type: PURCHASE_BUTTON_INFO_SUCCESS,
      payload: { ...response, group_id: params.group_id },
    });
  } catch (error) {
    dispatch({
      type: PURCHASE_BUTTON_INFO_ERROR,
      error,
    });
  }
};

export const clearPurchaseButtonInfo = () => dispatch => {
  dispatch({
    type: PURCHASE_BUTTON_INFO_ERROR,
  });
};
